/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationContentCreateDto } from '../../models/consultation-content-create-dto';
import { ConsultationContentDto } from '../../models/consultation-content-dto';

export interface ConsultationContentAdminControllerCreateV1$Params {
      body: ConsultationContentCreateDto
}

export function consultationContentAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: ConsultationContentAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
  const rb = new RequestBuilder(rootUrl, consultationContentAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationContentDto>;
    })
  );
}

consultationContentAdminControllerCreateV1.PATH = '/api/v1/consultation-contents/admin';
